import { useSetAtom } from 'jotai/index'
import { useEffect } from 'react'

import { contentFormValidityAtom } from '../generatorState'

export const useSyncFormSectionValidity = ({
	formId,
	isValid,
}: {
	formId: string
	isValid: boolean
}) => {
	const setIsContentFormValid = useSetAtom(contentFormValidityAtom)

	useEffect(() => {
		setIsContentFormValid((prev) => ({ ...prev, [formId]: isValid }))
	}, [formId, isValid, setIsContentFormValid])
}
